(function($) {
	$(function() {
		var $mobileStub = $('.mobileStub');

		var isMobileMenu = function() {
			if (app.sizes.width < app.mobileTo) {
				app.utils.menuClose();
				app.dom.$content.slideMobile();

				$('.loader-inner').on('click', function(e){
					e.preventDefault();
					window.location.reload(false);
				});

			} else {
				app.dom.$content.slideNav();

				$('.loader-inner').on('click', function(){
					var href = $(this).data('href');
					window.location.href= '/' + href;
				});
			}
		};

		var isMobile = function() {
			if (app.sizes.width < app.mobileTo) { //- если мобильный
				if (app.dom.$page.hasClass('page_desktop')) { // с mobile на desktop

					app.dom.$page.removeClass('page_desktop');

					if ($mobileStub.hasClass('open--mobile')) { //- если mobileStub уже был открыт
						$mobileStub.removeClass('open--mobile');
						window.location.reload(false); // все равно перезагружаем
					} else {
						$mobileStub.addClass('open--desktop');
					}
				}
				app.dom.$page.addClass('page_mobile');
			} else { //- если десктоп
				if (app.dom.$page.hasClass('page_mobile')) { // с desktop на mobile

					app.dom.$page.removeClass('page_mobile');

					if ($mobileStub.hasClass('open--desktop')) { //- если mobileStub уже был открыт
						$mobileStub.removeClass('open--desktop');
						window.location.reload(false); // все равно перезагружаем
					} else {
						$mobileStub.addClass('open--mobile');
					}
				}
				app.dom.$page.addClass('page_desktop');
			}
		};


		if ($('.header').hasClass('main')) {
			var support = { animations : Modernizr.cssanimations },
				container = document.getElementById( 'page' ),
				header = document.querySelector( 'header' ),
				loader = new PathLoader( document.getElementById( 'loader-circle' ) ),
				animEndEventNames = { 'WebkitAnimation' : 'webkitAnimationEnd', 'OAnimation' : 'oAnimationEnd', 'msAnimation' : 'MSAnimationEnd', 'animation' : 'animationend' },
				animEndEventName = animEndEventNames[ Modernizr.prefixed( 'animation' ) ];

			function init() {
				var onEndInitialAnimation = function() {
					if (support.animations) {
						this.removeEventListener(animEndEventName, onEndInitialAnimation);
					}
					$('.mainSlider').imagesLoaded({
						background: '.swiper-slide'
					}).done(function(){
						startLoading();
					});
				};
				// disable scrolling
				window.addEventListener('scroll', noscroll);

				// initial animation
				classie.add(container, 'loading');

				if (support.animations) {
					container.addEventListener(animEndEventName, onEndInitialAnimation);
				} else {
					onEndInitialAnimation();
				}
			};

			function startLoading() {
				var simulationFn = function(instance) {
					var progress = 0,
						interval = setInterval( function() {
							progress = Math.min( progress + Math.random() * 0.1, 1 );
							instance.setProgress( progress );

							// reached the end
							if( progress === 1 ) {
								classie.remove( container, 'loading' );
								classie.add( container, 'loaded' );
								clearInterval( interval );

								setTimeout(function(){
									isMobileMenu();
								}, 2000);

								var onEndHeaderAnimation = function(ev) {
									if( support.animations ) {
										if( ev.target !== header ) return;
										this.removeEventListener( animEndEventName, onEndHeaderAnimation );
									}
									window.removeEventListener( 'scroll', noscroll );
								};

								if( support.animations ) {
									header.addEventListener( animEndEventName, onEndHeaderAnimation );
								}
								else {
									onEndHeaderAnimation();
								}
							}
						}, 80);
				};
				loader.setProgressFn( simulationFn );
			};

			function noscroll() {
				window.scrollTo( 0, 0 );
			};

			init();
			isMobile();
			$(window).on('resize', isMobile);

		} else {
			isMobileMenu();
			isMobile();
			$(window).on('resize', isMobile);
		}
	});
})(jQuery);